function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useCallback } from "react";
import { register } from "@diana-ui/registry";
import {
  StyledText,
  Wrapper,
  TitleIcon,
  TextIcon,
  ContentWrapper,
  StyledTitle
} from "./Notification.style";

var Notification = _ref => {
  var { className, iconProps, id, text, title, onMouseOver, onMouseOut } = _ref;

  var handleMouseOver = () =>
    onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(id);

  var handleMouseOut = () =>
    onMouseOut === null || onMouseOut === void 0 ? void 0 : onMouseOut(id);

  var renderText = useCallback(
    () =>
      typeof text === "string" ? /*#__PURE__*/ React.createElement(StyledText, null, text) : text,
    [text]
  );
  var renderTitle = useCallback(
    () =>
      typeof title === "string"
        ? /*#__PURE__*/ React.createElement(StyledTitle, null, title)
        : title,
    [title]
  );
  return /*#__PURE__*/ React.createElement(
    Wrapper,
    {
      className: className,
      onMouseOver: handleMouseOver,
      onMouseOut: handleMouseOut
    },
    title &&
      (iconProps
        ? /*#__PURE__*/ React.createElement(
            ContentWrapper,
            null,
            /*#__PURE__*/ React.createElement(
              TitleIcon,
              _extends(
                {
                  size: 24
                },
                iconProps
              )
            ),
            renderTitle()
          )
        : renderTitle()),
    !title && iconProps
      ? /*#__PURE__*/ React.createElement(
          ContentWrapper,
          null,
          /*#__PURE__*/ React.createElement(
            TextIcon,
            _extends(
              {
                size: 24
              },
              iconProps
            )
          ),
          renderText()
        )
      : renderText()
  );
};

Notification.displayName = "Notificationn";
register(Notification);
export default Notification;
